import React, { ReactNode } from 'react';
import tw from 'tailwind-styled-components';
import styled from 'styled-components';

const Container = tw.div`
 flex
 items-center
 pt-8
 w-full
 pb-8
`;

const LabelForToggle = tw.label`
flex
items-center
cursor-pointer
`;

const RelativeDiv = tw.div`
  relative
`;

const InputToggle = tw.input`
sr-only
`;

const RoundedBox = tw.div`
w-10
h-4
bg-gray-400
rounded-full
shadow-inner
border-1
`;

const StyledInputToggle = styled(InputToggle as any)`
  &:checked ~ .dot {
    transform: translateX(200%);
  }
`;

const TransitionDiv = tw.div`
dot
absolute
w-3
h-3
rounded-full
shadow
inset-0.5
transition`;

const StyledRoundedBox = styled(RoundedBox as any)<{ state: boolean }>`
  background: ${(props) => (props.state === true ? '#2a2b2a' : '#f4f5f4')};
`;

const StyledTransitionDiv = styled(TransitionDiv as any)<{ state: boolean }>`
  background-color: ${(props) => (props.state === true ? '#f4f5f4' : '#2a2b2a')};
`;

const ToggleMessageDiv = tw.div`
ml-3
text-gray-700
uppercase
`;

export const SwitchComponent = ({
  id = 'switch-component',
  toggleSwitchLabel,
  setShowAssets,
  showAssets,
}: {
  id?: string;
  setShowAssets: any;
  showAssets: boolean;
  toggleSwitchLabel: string;
}): ReactNode => {
  const handleChange = () => {
    setShowAssets(() => !showAssets);
  };
  return (
    <>
      <Container data-test={`${id}-container`} data-print="hide">
        <LabelForToggle data-test={`${id}-label`} htmlFor="toggleA">
          <RelativeDiv>
            <StyledInputToggle
              data-test={`${id}input-toggle`}
              id="toggleA"
              type="checkbox"
              onChange={handleChange}
            />
            <StyledRoundedBox data-test={`${id}rounded-box`} state={showAssets} />
            <StyledTransitionDiv data-test={`${id}transition-div`} state={showAssets} />
          </RelativeDiv>
          <ToggleMessageDiv data-test={`${id}message-div`}>{toggleSwitchLabel}</ToggleMessageDiv>
        </LabelForToggle>
      </Container>
    </>
  );
};
